import { render, staticRenderFns } from "./SetupView.vue?vue&type=template&id=5d0f1ef8&"
import script from "./SetupView.vue?vue&type=script&lang=ts&"
export * from "./SetupView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports